{
    "UsersByExtensions_ModalTitle": "Benutzer",
    "UsersByExtensions_Filters": "Filter",
    "UsersByExtensions_AllPartitions": "Alle Standorte",
    "UsersByExtensions_Header_Users": "Erweiterung - Vollständiger Name",
    "UsersByExtensions_Header_MS_Licences": "MS-Lizenzen",
    "UsersByExtensions_UserFields_Email": "E-Mail",
    "UsersByExtensions_UserFields_Type": "Abonnement Typ",
    "UsersByExtensions_UserFields_UseEmailAsUser": "E-Mail als Benutzername verwenden",
    "UsersByExtensions_Username_Display_Title": "Benutzername",
    "UsersByExtensions_Username_Display_Title_No_Username": "Kein Benutzername\n(Sie können diesen Benutzer nicht erstellen)",
    "UsersByExtensions_UserFields_LegacyAppend": "{} (Vermächtnis)",
    "UsersByExtensions_UserType_Legacy_Akixi Lite": "Lite",
    "UsersByExtensions_UserType_Legacy_Akixi ONE": "ONE",
    "UsersByExtensions_UserType_Legacy_Akixi BLF": "Anwesenheit",
    "UsersByExtensions_UserType_Legacy_Akixi 1000": "1000",
    "UsersByExtensions_UserType_Legacy_Akixi 2000": "2000",
    "UsersByExtensions_UserFields_Checkbox_Tooltip": "Benutzer anlegen\/aktualisieren",
    "UsersByExtensions_UserFields_Cross_Tooltip": "Benutzer löschen",
    "UsersByExtension_UserType_NONE": "Überwachung deaktiviert (nicht lizenziert)",
    "UsersByExtension_UserType_ESSENTIALS": "Grundlegende Informationen",
    "UsersByExtension_UserType_ESSENTIALS_MST": "CXA-Standard",
    "UsersByExtension_UserType_PROFESSIONAL": "Professionell",
    "UsersByExtension_UserType_PROFESSIONAL_MST": "CXA-Prämie",
    "UsersByExtension_UserType_ENTERPRISE": "Unternehmen",
    "UsersByExtension_UserType_ENTERPRISE_MST": "CXA Fortgeschrittene",
    "UsersByExtension_UserType_CALL_CENTRE_AGENT": "Call-Center-Agent",
    "UsersByExtension_UserType_CALL_CENTRE_AGENT_MST": "CXE-Prämie",
    "UsersByExtension_UserType_CALL_CENTRE_SUPERVISOR": "Call-Center-Betreuer",
    "UsersByExtension_UserType_CALL_CENTRE_SUPERVISOR_MST": "CXE Fortgeschrittene",
    "UsersByExtension_UserType_IsNotAgent": "Dieser Benutzer hat einen Agenten, wenn Sie ihm dieses Abonnement geben, wird die Aktivität des Agenten nicht mehr überwacht.",
    "UsersByExtension_UserType_IsNone": "Die diesem Benutzer zugeordnete Nebenstelle wird nicht mehr überwacht, wenn Sie ihm dieses Abonnement geben",
    "UsersByExtension_Users_Multiple_Errors": "Es gibt mehrere Benutzer, die dieser Nebenstelle zugewiesen sind: {}",
    "UsersByExtensions_ConfirmUserDelete": "Klicken Sie erneut, um zu bestätigen, dass Sie den Zugriff auf die Berichte entfernen möchten?",
    "UserByExtension_LicenceTypes_EV": "EV-Lizenz",
    "UserByExtension_LicenceTypes_None": "Teams Benutzer",
    "LicenceSummary_Title": "Zusammenfassung der Lizenzen",
    "LicenceSummary_Headers_Type": "Typ",
    "LicenceSummary_Headers_InUse": "In Gebrauch",
    "LicenceSummary_Types_Essentials": "Grundlegende Informationen",
    "LicenceSummary_Types_Essentials_MST": "CXA-Standard",
    "LicenceSummary_Types_Professional": "Professionell",
    "LicenceSummary_Types_Professional_MST": "CXA-Prämie",
    "LicenceSummary_Types_Enterprise": "Unternehmen",
    "LicenceSummary_Types_Enterprise_MST": "CXA Fortgeschrittene",
    "LicenceSummary_Types_Unlicenced": "Nicht lizenziert",
    "AddAllUsers_Button_Title": "Benutzer für alle nicht überwachten Nebenstellen anlegen",
    "AddAllUsers_Button_Title_Interpolated": "Erstellen Sie {} Benutzer für alle nicht überwachten Nebenstellen",
    "NoUsersAdded": "Es wurden keine Benutzer hinzugefügt",
    "TooManyUsers_NoLicences": "Kann {} Benutzer nicht hinzufügen, da keine Lizenzen verfügbar sind",
    "TooManyUsers_UsersPlural_LicenceNonPlural": "Kann keine {} Benutzer hinzufügen, da nur {} Lizenz verfügbar ist",
    "TooManyUsers_UsersNonPlural_LicenceNonPlural": "Kann {} Benutzer nicht hinzufügen, da nur {} Lizenz verfügbar ist",
    "TooManyUsers_NoLicences_Plural": "Kann keine {} Benutzer hinzufügen, da keine Lizenzen verfügbar sind",
    "TooManyUsers": "Kann {} Benutzer nicht hinzufügen, da nur {} Lizenzen verfügbar sind",
    "TooManyUsers_Plural": "Kann keine {} Benutzer hinzufügen, da nur {} Lizenzen verfügbar sind",
    "SuccessfullyAddedUsers": "Lizenz für {} Benutzer mit \"{}\"-Lizenz erfolgreich erteilt",
    "AddAllUsers_PromptMessage": "Erstellen Sie Benutzer für alle nicht überwachten Nebenstellen mit \"{}\"-Lizenz.\n\nAlle nicht gespeicherten Änderungen gehen verloren. Sind Sie sicher, dass Sie fortfahren möchten?\n\n",
    "AddAllUsers_Confirm": "Bestätigen Sie",
    "AddAllUsers_Cancel": "Abbrechen",
    "AddAllUsers_CreatingUsers": "Hinzufügen von Benutzern mit \"{}\"-Lizenz...",
    "AddAllUsers_Loading": "Laden...",
    "NAME": "UsersByExtension",
    "UsersByExtensions_UserFields_CRM_Integration": "CX-Integration",
    "UsersByExtension_CrmLicenceType_SOLO": "Solo-CRM-Integration",
    "UsersByExtension_CrmLicenceType_TEAMS": "Teams CRM-Integration",
    "UsersByExtension_CrmLicenceType_UNITE": "CX-Integration",
    "UsersByExtension_CrmLicenceType_NONE": "Keine CRM-Integration",
    "LicenceSummary_Types_CallCentreAgent": "Callcenter-Mitarbeiter",
    "LicenceSummary_Types_CallCentreAgent_MST": "CXA Premium",
    "LicenceSummary_Types_CallCentreSupervisor": "Callcenter-Supervisor",
    "LicenceSummary_Types_CallCentreSupervisor_MST": "CXA Advanced",
    "LicenceSummary_Types_CXIntegration": "CX-Integration",
    "ProvisionAllCrm_Button_Title_Interpolated": "Erstellen\/Aktualisieren von Benutzern mit {}-Lizenz",
    "ProvisionAllCrm_PromptMessage": "Erstellen Sie mit {} Benutzer für alle nicht überwachten Erweiterungen. \n \n Alle nicht gespeicherten Änderungen gehen verloren. Möchten Sie wirklich fortfahren? \n \n",
    "TooManyUsers_MaxTelSysCapReached": "{} Benutzer können nicht hinzugefügt werden, da dies die vom Telefonsystem zugelassene maximale Anzahl von Benutzern überschreiten würde",
    "TooManyUsers_MaxTelSysCapReached_Plural": "Es können keine {} Benutzer hinzugefügt werden, da dies die vom Telefonsystem zugelassene maximale Anzahl von Benutzern überschreiten würde"
}